<template>
  <Dropdown
    v-model="genre"
    variant="input-like"
    :list="genres"
    empty-option
    could-be-empty
    :empty-text="$t('_web_genre-select_all', 'All')"
    :label="label || $t('_web_genre-select_label', 'Genre')"
    class="w-80 game-genres-select-wrapper"
    @input="$emit('input', $event)"
  >
    <slot slot="chosen" slot-scope="{ chosenItem }">
      <span class="chosen-item">{{ chosenItem.name }}</span>
    </slot>
    <div slot="item" slot-scope="{ item }">
      <Avatar
        class="h-mr-2"
        type="genre"
        :size="24"
        :img-url="item.logo && item.logo.uri"
      />
      <span>
        {{ item.name }}
      </span>
    </div>
  </Dropdown>
</template>

<script>
import Avatar from '@/components/images/Avatar';
import Dropdown from '@/components/molecules/form/HeraFormDropdown';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'GameGenresSelectBox',
  components: {
    Avatar,
    Dropdown,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: Object,
      default: () => {},
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      genre: this.value,
    };
  },
  computed: {
    ...mapGetters(['genres']),
  },
  watch: {
    value(newVal) {
      if (!newVal) {
        this.genre = null;
      }
    },
  },
  created() {
    this.fetchGenres();
  },
  methods: {
    ...mapActions(['fetchGenres']),
  },
};
</script>
<style lang="scss">
.game-genres-select-wrapper {
  &.dropdown--input-like {
    .dropdown_activator {
      width: 100%;
      min-width: 150px;
    }
  }
}
</style>
